// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Unscramble from "../Unscramble/index.js";
var PromotionId = function (x) {
    return x;
};
var LoyaltyStampId = function (x) {
    return x;
};
var showPromotionId = Data_Show.showInt;
var showLoyaltyStampId = Data_Show.showInt;
var ordPromotionId = Data_Ord.ordInt;
var ordLoyaltyStampId = Data_Ord.ordInt;
var newtypePromotionId_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeLoyaltyStampId_ = {
    Coercible0: function () {
        return undefined;
    }
};
var eqPromotionId = Data_Eq.eqInt;
var eqLoyaltyStampId = Data_Eq.eqInt;
var encodePromotionId = Foreign_Generic_Class.intEncode;
var encodeLoyaltyStampId = Foreign_Generic_Class.intEncode;
var decodePromotionId = Unscramble.decodeInt1;
var decodePromotionId1 = Foreign_Generic_Class.intDecode;
var decodeLoyaltyStampId = Unscramble.decodeInt1;
var decodeLoyaltyStampId1 = Foreign_Generic_Class.intDecode;
export {
    PromotionId,
    LoyaltyStampId,
    newtypePromotionId_,
    showPromotionId,
    eqPromotionId,
    ordPromotionId,
    encodePromotionId,
    decodePromotionId1,
    decodePromotionId,
    newtypeLoyaltyStampId_,
    showLoyaltyStampId,
    eqLoyaltyStampId,
    ordLoyaltyStampId,
    encodeLoyaltyStampId,
    decodeLoyaltyStampId1,
    decodeLoyaltyStampId
};
